module.exports = "/pages/business/foodslabo/service_icon_5.png";